exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.diy-video-cover{ width: 200px;\n}\n.diy-video-cover img{ width: 100%;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/page/page/diy/params/Video.vue"],"names":[],"mappings":";AACA,kBAAkB,aAAa;CAC9B;AACD,sBAAsB,YAAY;CACjC","file":"Video.vue","sourcesContent":["\n.diy-video-cover{ width: 200px;\n}\n.diy-video-cover img{ width: 100%;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f7fe514","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/page/page/diy/params/Video.vue
// module id = ZqPX
// module chunks = 0